<template>
  <div class="big-box">
    <!-- 主体部分 -->
    <div class="main">
      <!-- 辟谣要闻与公告栏部分 -->
      <div class="news">
        <div class="left">
          <div class="left-swiper">
            <swiper ref="zxfb" class="left-swiper" :options="swiperOptions">
              <swiper-slide
                v-for="(item, index) in advers.sliderAd"
                :key="index"
              >
                <a class="left-swiper" :href="item.href">
                  <img
                    class="news-image zxfb"
                    :src="cfg.imageDomain + item.url"
                    alt=""
                    :data-id="item.srcid"
                  >
                  <p>{{ item.title }}</p>
                </a>
              </swiper-slide>
              <div slot="pagination" class="swiper-pagination" />
            </swiper>
            <img
              class="swiper-button-prev swiper-prev"
              :src="cfg.ossDomain + '/prev.png'"
            ><!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
            <img
              class="swiper-button-next swiper-next"
              :src="cfg.ossDomain + '/next.png'"
            ><!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
          </div>
          <div class="platform-list">
            <a
              v-for="item in platformList"
              :key="item.name"
              :href="item.link"
              target="_blank"
            >
              <img class="platform-icon" :src="item.imgPath">
            </a>
          </div>
        </div>
        <!-- 最新发布 -->
        <div class="news-content zxfb">
          <bigTitle
            :title="homeColumns.zxfb.title"
            @click.native="goColumn(homeColumns.zxfb.title)"
          />
          <div class="news-list">
            <!-- @mousemove.native="mouseMoveNews(index,'zxfb')" -->
            <smallTitle
              v-for="(item, index) in homeColumns.zxfb.list"
              :key="index"
              :title="item.title"
              :tag="isSheQianRumor(item) ? '涉黔' : ''"
              :time="
                (item.publishedtime || item.createtime)
                  | parseTime('{y}-{m}-{d}')
              "
              @click.native="goNewsDetail(item.id, item.customUrl)"
            />
          </div>
        </div>
      </div>
      <!-- <div class="small-banner">
        <img src="http://resources.mmgzsw.org.cn/attaches/image/20190919/Group.png" alt>
      </div> -->

      <!-- 谣言终结 -->
      <div class="card yyzj">
        <div class="title">
          <bigTitle
            :title="homeColumns.yyzj.title"
            @click.native="goColumn(homeColumns.yyzj.title)"
          />
        </div>
        <div class="card-list">
          <div
            v-for="(item, index) in homeColumns.yyzj.list"
            :key="index"
            class="card-item"
            @click="goNewsDetail(item.id, item.customUrl)"
          >
            <div class="img-box">
              <span
                :style="
                  'background-image: url(' + cfg.imageDomain + item.img + ')'
                "
                alt
              />
            </div>
            <div class="card-title">{{ item.title }}</div>
            <div class="card-footer">
              <div class="custom-name">{{ item.author || item.source }}</div>
              <div class="publish-time">
                {{ item.publishedtime | parseTime("{y}-{m}-{d}") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <img
        v-if="advers.homeBanner.length"
        class="news-image jcdt"
        :src="cfg.imageDomain + advers.homeBanner[0].thumbnailPath"
        alt=""
        :data-jump-url="advers.homeBanner[0].jumpUrl"
        @click="navigationUrl(advers.homeBanner[0].jumpUrl)"
      >

      <!-- 涉企网络辟谣 -->
      <div class="card sqwlpy">
        <div class="title">
          <bigTitle
            :title="homeColumns.sqwlpy.title"
            @click.native="goColumn(homeColumns.sqwlpy.title)"
          />
        </div>
        <div class="card-list">
          <div
            v-for="(item, index) in homeColumns.sqwlpy.list"
            :key="index"
            class="card-item"
            @click="goNewsDetail(item.id, item.customUrl)"
          >
            <div class="img-box">
              <span
                :style="
                  'background-image: url(' + cfg.imageDomain + item.img + ')'
                "
                alt
              />
            </div>
            <div class="card-title">{{ item.title }}</div>
            <div class="card-footer">
              <div class="custom-name">{{ item.author || item.source }}</div>
              <div class="publish-time">
                {{ item.publishedtime | parseTime("{y}-{m}-{d}") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 权威发布 -->
      <div class="card qwfb">
        <div class="title">
          <bigTitle
            :title="homeColumns.qwfb.title"
            @click.native="goColumn(homeColumns.qwfb.title)"
          />
        </div>
        <div class="card-list">
          <div
            v-for="(item, index) in homeColumns.qwfb.list"
            :key="index"
            class="card-item"
            @click="goNewsDetail(item.id, item.customUrl)"
          >
            <div class="img-box">
              <span
                :style="
                  'background-image: url(' + cfg.imageDomain + item.img + ')'
                "
                alt
              />
            </div>
            <div class="card-title">{{ item.title }}</div>
            <div class="card-footer">
              <div class="custom-name">{{ item.author || item.source || '—' }}</div>
              <div class="publish-time">
                {{ item.publishedtime | parseTime("{y}-{m}-{d}") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 政策法规 -->
      <div class="card zcfg">
        <div class="title">
          <bigTitle
            :title="homeColumns.zcfg.title"
            @click.native="goColumn(homeColumns.zcfg.title)"
          />
        </div>
        <div class="card-list">
          <div
            v-for="(item, index) in homeColumns.zcfg.list"
            :key="index"
            class="card-item"
            @click="goNewsDetail(item.id, item.customUrl)"
          >
            <div class="img-box">
              <span
                :style="
                  'background-image: url(' + cfg.imageDomain + item.img + ')'
                "
                alt
              />
            </div>
            <div class="card-title">{{ item.title }}</div>
            <div class="card-footer">
              <div class="custom-name">{{ item.author || item.source || '—' }}</div>
              <div class="publish-time">
                {{ item.publishedtime | parseTime("{y}-{m}-{d}") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 节气掠影改成二十四节气·辟谣集 -->
      <div class="card jqly">
        <div class="title">
          <bigTitle
            :title="homeColumns.jqly.title"
            @click.native="goColumn(homeColumns.jqly.title)"
          />
        </div>
        <div class="card-list">
          <div
            v-for="(item, index) in homeColumns.jqly.list"
            :key="index"
            class="card-item"
            @click="goNewsDetail(item.id, item.customUrl)"
          >
            <div class="img-box">
              <span
                :style="
                  'background-image: url(' + cfg.imageDomain + item.img + ')'
                "
                alt
              />
            </div>
            <div class="card-title">{{ item.title }}</div>
            <div class="card-footer">
              <div class="custom-name">{{ item.author || item.source || '—' }}</div>
              <div class="publish-time">
                {{ item.publishedtime | parseTime("{y}-{m}-{d}") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 经典案例 -->
      <div class="card jdal">
        <div class="title">
          <bigTitle
            :title="homeColumns.jdal.title"
            @click.native="goColumn(homeColumns.jdal.title)"
          />
        </div>
        <div class="card-list">
          <div
            v-for="(item, index) in homeColumns.jdal.list"
            :key="index"
            class="card-item"
            @click="goNewsDetail(item.id, item.customUrl)"
          >
            <div class="img-box">
              <span
                :style="
                  'background-image: url(' + cfg.imageDomain + item.img + ')'
                "
                alt
              />
            </div>
            <div class="card-title">{{ item.title }}</div>
            <div class="card-footer">
              <div class="custom-name">{{ item.author || item.source || '—' }}</div>
              <div class="publish-time">
                {{ item.publishedtime | parseTime("{y}-{m}-{d}") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 贵州网络辟谣作品展播 -->
      <div class="card jdal">
        <div class="title">
          <bigTitle
            :title="homeColumns.gzwlpyzpzb.title"
            @click.native="goColumn(homeColumns.gzwlpyzpzb.title)"
          />
        </div>
        <div class="card-list">
          <div
            v-for="(item, index) in homeColumns.gzwlpyzpzb.list"
            :key="index"
            class="card-item"
            @click="goNewsDetail(item.id, item.customUrl)"
          >
            <div class="img-box">
              <span
                :style="
                  'background-image: url(' + cfg.imageDomain + item.img + ')'
                "
                alt
              />
            </div>
            <div class="card-title">{{ item.title }}</div>
            <div class="card-footer">
              <div class="custom-name">{{ item.author || item.source || '—' }}</div>
              <div class="publish-time">
                {{ item.publishedtime | parseTime("{y}-{m}-{d}") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 工作动态 涨知识 -->
      <div class="service">
        <!-- 工作动态 -->
        <div class="service-left gzdt">
          <bigTitle
            :title="homeColumns.gzdt.title"
            @click.native="goColumn(homeColumns.gzdt.title)"
          />
          <smallTitle
            v-for="(item, index) in homeColumns.gzdt.list"
            :key="index"
            :title="item.title"
            :time="item.publishedtime | parseTime('{y}-{m}-{d}')"
            @click.native="goNewsDetail(item.id, item.customUrl)"
          />
        </div>
        <!-- 涨知识 -->
        <div class="service-right zzs">
          <bigTitle
            :title="homeColumns.zzs.title"
            @click.native="goColumn(homeColumns.zzs.title)"
          />
          <smallTitle
            v-for="(item, index) in homeColumns.zzs.list"
            :key="index"
            :title="item.title"
            :time="item.publishedtime | parseTime('{y}-{m}-{d}')"
            @click.native="goNewsDetail(item.id, item.customUrl)"
          />
        </div>
      </div>
      <bigTitle
        title="贵州网络辟谣联动机制辟谣平台矩阵"
        style="margin-top: 30px"
        class="custom-title"
      />

      <!-- 友情链接 -->
      <div class="link-container">
        <div class="link">
          <div class="link-label">机制成员单位</div>
          <div class="link-content">
            <a
              v-for="(item, index) in provinceLinks"
              :key="index"
              :href="item.url"
              class="link-item"
              target="_blank"
              :title="item.name"
            >
              <img :src="item.img" :alt="item.name" class="link-img">
            </a>
          </div>
        </div>
        <div class="link">
          <div class="link-label">市州</div>
          <div class="link-content">
            <a
              v-for="(item, index) in cityLinks"
              :key="index"
              :href="item.url"
              class="link-item"
              target="_blank"
              :title="item.name"
            >
              <img :src="item.img" :alt="item.name" class="link-img">
            </a>
          </div>
        </div>
        <div class="link">
          <div class="link-label">新闻单位</div>
          <div class="link-content">
            <a
              v-for="(item, index) in newsLinks"
              :key="index"
              :href="item.url"
              class="link-item"
              target="_blank"
              :title="item.name"
            >
              <img :src="item.img" :alt="item.name" class="link-img">
            </a>
          </div>
        </div>
      </div>
      <!-- 横幅 -->
      <!-- <swiper
        class="small-banner"
        :options="swiperOptions"
      >
        <swiper-slide
          v-for="(item, index) in advers.homeBanner"
          :key="index"
          class="small-banner"
        > -->
      <!-- </swiper-slide> -->
      <!-- </swiper> -->
    </div>
  </div>
</template>

<script>
import bigTitle from '@/components/bigTitle';
import smallTitle from '@/components/smallTitle';
import { getArticleList, getAdvert } from '@/api/common';
import UrlUtils from '@/utils/UrlUtils.js';

export default {
  name: 'Index',
  components: {
    bigTitle,
    smallTitle
  },
  data() {
    const _this = this;
    return {
      provinceLinks: [
        {
          name: '贵州省公安厅',
          img: 'https://bxgz-image.gztvbxgz.cn/resPhotoLib/2025/09/08/573ddf8cf5ab4ddc8ed24335bee473a7.jpg', // 填写图片地址
          url: 'https://gat.guizhou.gov.cn/'
        },
        {
          name: '省教育厅',
          img: 'https://sf-images.v2gogo.com/piyao/gzs-jyt.png', // 填写图片地址
          url: 'https://jyt.guizhou.gov.cn/'
        },
        {
          name: '省卫健委',
          img: 'https://sf-images.v2gogo.com/piyao/gzs-wjw.png', // 填写图片地址
          url: 'https://wjw.guizhou.gov.cn/'
        },
        {
          name: '省文旅厅',
          img: 'https://bxgz-image.gztvbxgz.cn/resPhotoLib/2025/09/08/51239827b4be4d4e832d2555c9045b94.jpg', // 填写图片地址
          url: 'https://whhly.guizhou.gov.cn/'
        },
        {
          name: '省民政厅',
          img: 'https://sf-images.v2gogo.com/piyao/gzs-mzt.png', // 填写图片地址
          url: 'https://mzt.guizhou.gov.cn/'
        },
        {
          name: '省人社厅',
          img: 'https://bxgz-image.gztvbxgz.cn/resPhotoLib/2025/09/08/7cf49a350c194365acc66b6246f74212.jpg', // 填写图片地址
          url: 'https://rst.guizhou.gov.cn/'
        },
        {
          name: '省农业厅',
          img: 'https://bxgz-image.gztvbxgz.cn/resPhotoLib/2025/09/08/ba4f7da7401e415499cae2a83292d6b5.jpg', // 填写图片地址
          url: 'https://nynct.guizhou.gov.cn/'
        },
        {
          name: '省商务厅',
          img: 'https://bxgz-image.gztvbxgz.cn/resPhotoLib/2025/09/08/e50565e8c22f446393abf7eaa81fbdce.jpg', // 填写图片地址
          url: 'https://swt.guizhou.gov.cn/'
        },
        {
          name: '省市场监管局',
          img: 'https://bxgz-image.gztvbxgz.cn/resPhotoLib/2025/09/08/29e7da2a497245e48b3c4038798b0649.jpg', // 填写图片地址
          url: 'https://amr.guizhou.gov.cn/'
        },
        {
          name: '省体育局',
          img: 'https://bxgz-image.gztvbxgz.cn/resPhotoLib/2025/09/08/31c718e7c4de4e14aeb83859a1e7561a.jpg', // 填写图片地址
          url: 'https://tyj.guizhou.gov.cn/'
        },
        {
          name: '省气象局',
          img: 'https://bxgz-image.gztvbxgz.cn/resPhotoLib/2025/09/08/ba1672f7994c4f379065c2f7897d58d4.jpg', // 填写图片地址
          url: 'http://gz.cma.gov.cn/'
        },
        {
          name: '省妇联',
          img: 'https://bxgz-image.gztvbxgz.cn/resPhotoLib/2025/09/08/3f6a388e35c0436b921faa4b139cf1bd.jpg', // 填写图片地址
          url: 'http://www.gzswomen.org.cn/'
        },
        {
          name: '省红十字会',
          img: 'https://bxgz-image.gztvbxgz.cn/resPhotoLib/2025/09/08/767f96057f30426d82a8423d1a48df24.jpg', // 填写图片地址
          url: 'http://www.gzredcross.cn/'
        },
        {
          "name": "省委宣传部",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image33.png",
          "url": "https://gzxc.gov.cn/"
        },
        {
          "name": "省委网信办",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image32.png",
          "url": "https://jubao.gog.cn/index"
        },
        {
          "name": "省高级人民法院",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image1.png",
          "url": "https://www.guizhoucourt.gov.cn/gzdt/280058.jhtml"
        },
        {
          "name": "省人民检察院",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image2.png",
          "url": "http://www.gz.jcy.gov.cn/"
        },
        {
          "name": "省委组织部",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image3.png",
          "url": "https://www.gzzzb.gov.cn/"
        },
        {
          "name": "省委统战部",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image4.png",
          "url": "https://www.gzswtzb.org.cn/"
        },
        {
          "name": "省委政法委",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image5.png",
          "url": "http://www.gzpeace.gov.cn/n1371/index.html"
        },
        {
          "name": "省委社会工作部",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image6.png",
          "url": "http://www.gzshgz.gov.cn/"
        },
        {
          "name": "省委金融办",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image7.png",
          "url": "https://jr.guizhou.gov.cn/"
        },
        {
          "name": "省委党史研究室",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image31.png",
          "url": "https://www.zggzswdsyjs.cn/"
        },
        {
          "name": "省委台办",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image9.png",
          "url": "https://gd.huaxia.com/gz-tw/"
        },
        {
          "name": "省科技厅",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image11.png",
          "url": "https://kjt.guizhou.gov.cn/"
        },
        {
          "name": "省工业和信息化厅",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image12.png",
          "url": "https://gxt.guizhou.gov.cn/"
        },
        {
          "name": "省国家安全厅",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image14.png",
          "url": "https://zwfw.guizhou.gov.cn/zxmh/bmqjd.do?areacode=520000&ocode=-7830086204211445719&orgcode=35086"
        },
        {
          "name": "省司法厅",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image16.png",
          "url": "https://sft.guizhou.gov.cn/"
        },
        {
          "name": "省财政厅",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image19.png",
          "url": "https://czt.guizhou.gov.cn/"
        },
        {
          "name": "省自然资源厅",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image18.png",
          "url": "https://zrzy.guizhou.gov.cn/"
        },
        {
          "name": "省生态环境厅",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image20.png",
          "url": "https://sthj.guizhou.gov.cn/"
        },
        {
          "name": "省住房和城乡建设厅",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image21.png",
          "url": "https://zfcxjst.guizhou.gov.cn/"
        },
        {
          "name": "省交通运输厅",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image22.png",
          "url": "https://jt.guizhou.gov.cn/"
        },
        {
          "name": "省退役军人事务厅",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image27.png",
          "url": "https://tyjrswt.guizhou.gov.cn/"
        },
        {
          "name": "省应急管理厅",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image28.png",
          "url": "https://yjgl.guizhou.gov.cn/"
        },
        {
          "name": "省外事办省国资委",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image29.png",
          "url": "https://gzw.guizhou.gov.cn/ztzl/"
        },
        {
          "name": "贵州省广播电视局",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image34.png",
          "url": "https://gbdsj.guizhou.gov.cn/"
        },
        {
          "name": "贵州省医保局",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image35.png",
          "url": "https://ylbzj.guizhou.gov.cn/"
        },
        {
          "name": "贵州省大数据局",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image36.png",
          "url": "https://dsj.guizhou.gov.cn/"
        },
        {
          "name": "贵州省中医药管理局",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image37.png",
          "url": "https://atcm.guizhou.gov.cn/home/index.html"
        },
        {
          "name": "贵州省投资促进局",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image38.png",
          "url": "https://invest.guizhou.gov.cn/"
        },
        {
          "name": "贵州省总工会",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image39.png",
          "url": "https://www.guizgh.org.cn/"
        },
        {
          "name": "贵州团省委",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image40.png",
          "url": "https://www.gzyouth.cn/"
        },
        {
          "name": "贵州省科学技术协会",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image41.png",
          "url": "http://www.gast.org.cn/"
        },
        {
          "name": "贵州省工商联合会",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image42.png",
          "url": "https://www.gzsgsl.gov.cn/"
        },
        {
          "name": "贵州省社会科学界联合会",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image43.png",
          "url": "http://www.gzskl.gov.cn/"
        },
        {
          "name": "贵州省残疾人联合会",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image44.png",
          "url": "http://www.gzsdpf.org.cn/"
        },
        {
          "name": "贵州省归国华侨联合会",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image45.png",
          "url": "http://www.gzql.org.cn/"
        },
        {
          "name": "贵州省作家协会",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image60.png",
          "url": "https://www.gzszjxh.cn/?use_xbridge3=true&loader_name=forest&need_sec_link=1&sec_link_scene=im&theme=light"
        },
        {
          "name": "贵州省通信管理局",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image46.png",
          "url": "https://gzca.miit.gov.cn/"
        },
        {
          "name": "中国人民银行贵州省分行",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image47.png",
          "url": "https://guiyang.pbc.gov.cn/"
        },
        {
          "name": "中国证监会贵州监管局",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image48.png",
          "url": "https://www.csrc.gov.cn/guizhou/"
        },
        {
          "name": "贵阳海关",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image49.png",
          "url": "http://guiyang.customs.gov.cn/"
        },
      ],
      cityLinks: [
        {
          "name": "贵阳贵安互联网联合辟谣平台",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/image61.png",
          "url": "https://www.gywb.cn/nuxtchannel/gyPy/0gyw0gypy0"
        },
        {
          "name": "黔西南州互联网联合辟谣平台",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/image62.png",
          "url": "https://piyao.qxnca.gov.cn/biyaoyaowen/"
        },
        {
          "name": "贵阳市委网信办",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image51.png",
          "url": "https://www.guiyang.gov.cn/zwgk/shlwxxbgs/"
        },
        {
          "name": "遵义市委网信办",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image52.png",
          "url": "https://www.zunyi.gov.cn/zwgk/zfxxgkzl/zfxxgkgzndbg/ygdw/shlwxxb/"
        },
        {
          "name": "六盘水市委网信办",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image53.png",
          "url": "https://www.gzlps.gov.cn/"
        },
        {
          "name": "安顺市委网信办",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image54.png",
          "url": "https://www.anshun.gov.cn/?id=71367&itemid=532"
        },
        {
          "name": "毕节市委网信办",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image55.png",
          "url": "https://www.bijie.gov.cn/"
        },
        {
          "name": "铜仁市委网信办",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image56.png",
          "url": "https://trs.gov.cn/"
        },
        {
          "name": "黔东南州委网信办",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image57.png",
          "url": "https://www.qdn.gov.cn/"
        },
        {
          "name": "黔南州委网信办",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image58.png",
          "url": "https://www.qiannan.gov.cn/"
        },
        {
          "name": "黔西南州委网信办",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image59.png",
          "url": "https://www.qxn.gov.cn/"
        }
      ],
      newsLinks: [
        {
          "name": "贵州日报报刊社",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image8.png",
          "url": "https://www.eyesnews.cn/"
        },
        {
          "name": "新华社贵州分社",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image61.png",
          "url": "http://www.gz.xinhuanet.com/"
        },
        {
          "name": "人民日报社贵州分社",
          "img": "https://bxgz-image.gztvbxgz.cn/resPhotoLib/2026/04/20/media/image50.png",
          "url": "https://local.cctv.com/guizhou/index.shtml"
        },
        {
          name: '天眼新闻',
          img: 'https://bxgz-image.gztvbxgz.cn/resPhotoLib/2025/09/08/e15c81a3d49846dfb837f4f16e1e368f.jpg', // 填写图片地址
          url: 'https://www.eyesnews.cn/'
        },
        {
          name: '动静新闻',
          img: 'https://bxgz-image.gztvbxgz.cn/resPhotoLib/2025/09/08/4de8d3944cfd47d7a75903f8f669af62.jpg', // 填写图片地址
          url: 'https://www.gzstv.com/news/headlines'
        },
        {
          name: '多彩网',
          img: 'https://bxgz-image.gztvbxgz.cn/resPhotoLib/2025/09/08/29b95a6d81b64255aa4c958c7b2c9e0e.jpg', // 填写图片地址
          url: 'http://www.gog.cn/'
        },
      ],
      swiperOptions: {
        autoplay: true,
        loop: true,
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          click: function(e) {
            const { id } = e.target.dataset;
            if (id) {
              _this.goNewsDetail(id);
            }
          }
        }
      },
      platformList: [
        {
          name: '网络谣言曝光平台',
          imgPath: this.cfg.ossDomain + '/wlyybgpt.png',
          link: 'https://www.piyao.org.cn/yybgt/index.htm'
        },
        {
          name: '举报平台',
          imgPath: this.cfg.ossDomain + '/jbpt.png',
          link: 'http://jubao.gog.cn/'
        },
        {
          name: '辟谣平台',
          imgPath: this.cfg.ossDomain + '/pyjbpt.png',
          link: '#/publish-piyao'
        }
      ],

      // 栏目列表
      homeColumns: {
        zxfb: {
          title: '最新发布',
          pageSize: 5,
          list: []
        },
        // 谣言终结
        yyzj: {
          title: '谣言终结',
          pageSize: 4,
          list: []
        },
        // 涉企网络辟谣
        sqwlpy: {
          title: '涉企网络辟谣',
          pageSize: 4,
          list: []
        },
        // 权威发布
        qwfb: {
          title: '权威发布',
          pageSize: 4,
          list: []
        },
        // 政策法规
        zcfg: {
          title: '政策法规',
          pageSize: 4,
          list: []
        },
        // 节气掠影改成二十四节气·辟谣集
        jqly: {
          title: '二十四节气·辟谣集',
          pageSize: 4,
          list: []
        },
        // --------------
        gzdt: {
          title: '工作动态',
          pageSize: 6,
          list: []
        },
        // 经典案例
        jdal: {
          title: '经典案例',
          pageSize: 4,
          list: []
        },
        // 贵州网络辟谣作品展播
        gzwlpyzpzb: {
          title: '作品展播',
          pageSize: 4,
          list: []
        },
        // 涨知识
        zzs: {
          title: '识谣辨谣',
          pageSize: 6,
          list: []
        }
      },
      // 广告
      advers: {
        sliderAd: [],
        homeBanner: []
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // 获取展示数据
      for (const key in this.homeColumns) {
        const column = this.homeColumns[key];

        if (column.chidren) {
          column.chidren.forEach((element, index) => {
            const columnName = element.title;
            this.getArticleList(columnName, key, index);
          });
        } else {
          const columnName = column.title;
          this.getArticleList(columnName, key);
        }
      }

      // 获取广告信息
      this.getAdvert();
    },
    getArticleList(columnName, key, index) {
      const pageSize = this.homeColumns[key].pageSize || 12;
      const data = { pageNo: 1, pageSize: pageSize, type: 16 };
      data.customLabel = columnName === '最新发布' ? '' : columnName;
      getArticleList(data).then((res) => {
        if (index === 0 || index > 0) {
          this.homeColumns[key].chidren[index].list = res.data.rows || [];
        } else {
          this.homeColumns[key].list = res.data.rows || [];
        }
      });
    },
    // 是否为涉黔谣言（customLabel 可能为多标签拼接，故用包含判断）
    isSheQianRumor(item) {
      return String((item && item.customLabel) || '').includes('涉黔谣言');
    },
    // 新闻列表
    // mouseMoveNews(index, key) {
    //   this.$nextTick(() => {
    //     this.$refs[key].$swiper.slideTo(index + 1, 1000, false);
    //   });
    // },
    // 获取首页广告
    getAdvert() {
      getAdvert().then((res) => {
        this.advers['sliderAd'] = res.data;
      });
    },
    // 跳转新闻详情
    goNewsDetail(id, customUrl) {
      if (customUrl) {
        var windowOpen = window.open();
        windowOpen.location = customUrl;
      } else {
        this.$router.push({
          path: '/news',
          query: {
            id
          }
        });
      }
    },
    // 跳转栏目
    goColumn(name) {
      this.$router.push({
        path: '/subPage',
        query: {
          name
        }
      });
    },
    navigationUrl(appLink) {
      const urlUtils = new UrlUtils();
      urlUtils.receiveLinkUri(appLink, this);
    }
  }
};
</script>

<style lang="less" scoped>
.big-box {
  width: 100%;
  .main {
    width: 1200px;
    margin: 0 auto;
    .news {
      width: 1200px;
      // height: 350px;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 20px 0 0;
      .left-swiper {
        width: 587px;
        height: 271px;
        text-align: center;
        position: relative;
        margin-left: 0;
        > .news-image.zxfb {
          width: 100%;
          height: 100%;
        }
        p {
          width: 100%;
          height: 30px;
          padding-right: 100px;
          box-sizing: border-box;
          line-height: 30px;
          position: absolute;
          left: 0;
          bottom: 0;
          font-size: 14px;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
          box-sizing: border-box;
          padding-left: 12px;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &:hover .swiper-prev {
          display: block;
        }
        &:hover .swiper-next {
          display: block;
        }
      }
      .news-content {
        width: 587px;
        height: 353px;
        overflow: hidden;
        .news-list {
          // width: 487px;
          // height: 280px;
          // overflow: hidden;
        }
      }
    }
    .small-banner {
      width: 100%;
      max-width: 1200px;
      height: auto;
      margin: 20px auto 0;
      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }
    .service {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 20px;
      .service-left {
        flex: 1;
        margin-right: 20px;
        min-width: 300px;
      }
      .service-right {
        flex: 1;
        min-width: 300px;
      }
    }
    .link-container {
      width: 100%;
      max-width: 1200px;
      margin: 10px auto 0 auto;
      display: flex;
      flex-direction: column;
      gap: 8px 4px;
      justify-items: center;
      align-items: center;
      border-radius: 5px;
      border: 1px solid blue;
      padding: 10px;
    }
    .link {
      width: 100%;
      display: flex;
      align-items: flex-start;
      .link-label {
        width: 105px;
        min-width: 60px;
        font-weight: bold;
        color: #333;
        padding-top: 10px;  /* 保持与图片对齐 */
        text-align: justify;
        text-align-last: justify;
        white-space: nowrap;
      }
      .link-content {
        flex: 1;            /* 占据剩余所有空间 */
        display: grid;
        grid-template-columns: repeat(6, 1fr); /* 内部维持 6 列 */
        gap: 8px 4px;

        .link-item {
          width: 100%;
          padding: 10px 0;
          height: 100%;
          min-width: 0;
          text-align: center;
          box-sizing: border-box;
          text-decoration: none;
          transition: box-shadow 0.2s;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          &:hover {
            box-shadow: 0 2px 8px #eee;
          }

          .link-img {
            width: 100%;
            max-width: 160px; /* 适当减小最大宽度防止拥挤 */
            display: block;
            object-fit: contain;
            background: #f5f5f5;
            border-radius: 2px;
            margin-bottom: 8px;
          }
        }
      }
    }
    .card {
      width: 1200px;
      // height: 305px;
      margin: 40px auto 0;
      overflow: hidden;
      .card-list {
        width: 100%;
        margin: 10px 0;
        display: flex;
        flex-wrap: nowrap; /* PC端不换行 */
        justify-content: space-between;
        // display: flex;
        white-space: nowrap;
        .card-item {
          width: 280px;
          height: 314px;
          min-height: 314px;
          background: #ffffff;
          border: 1px solid #e5e5e5;
          box-shadow: 0px 4px 10px rgba(51, 51, 51, 0.15);
          display: inline-flex;
          flex-direction: column;
          box-sizing: border-box;
          position: relative;
          margin-right: 25px;
          margin-bottom: 0;
          transition: all 0.2s linear;
          &:nth-last-child(1) {
            margin-right: 0;
          }
          > .img-box {
            span {
              width: 100%;
              height: auto;
              aspect-ratio: 280 / 210;
              display: block;
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }
          }
          > .card-title {
            width: 100%;
            height: 58px;
            margin: 10px 0;
            padding: 0 10px;
            background: #fff;
            white-space: pre-wrap;
            display: -webkit-box;
            overflow: hidden;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            font: 400 16px/21px "宋体";
            color: #000;
          }
          .card-footer {
            display: flex;
            justify-content: space-between;
            margin: 10px 10px 0;
            padding: 7px 0 10px;
            border-top: 1px solid #e5e5e5;
            .custom-name {
              font-size: 12px;
              font-weight: 300;
              line-height: 16px;
              color: #999999;
            }
            .publish-time {
              font-size: 12px;
              font-weight: 300;
              line-height: 16px;
              color: #999999;
            }
          }
        }
        .card-item:hover {
          box-shadow: 0 6px 6px #999;
          transform: translate3d(0, -2px, 0);
        }
      }
    }
    .title {
      position: relative;
    }
  }
  .link-item {
    display: inline-block;
  }
}

.custom-title /deep/ .more {
  display: none;
}

.padding10 {
  padding: 0 10px;
}
.mt15 {
  margin-top: 14px;
}
.swiper-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
// 平台列表
.platform-list {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  flex-wrap: wrap;
  .platform-icon {
    width: 100%;
    height: auto;
    max-width: 189px;
  }
}

@media screen and (max-width: 768px) {
  .big-box .main {
    width: 100%;
    margin-top: 10px;
    padding: 0 10px;

    .news {
      flex-direction: row;
      flex-wrap: wrap;
      width: 100%;

      .left {
        width: 50%;
        max-width: 50%;
        box-sizing: border-box;
        padding-right: 6px;
        margin-bottom: 10px;
        .left-swiper {
          width: 100%;
          height: auto;
        }
        .platform-list {
          display: flex;
          width: 100%;
          flex-direction: row;
          justify-content: space-between;
          margin-top: 10px;
          flex-wrap: wrap;
          .platform-icon {
            width: 100%;
            height: 40px;
            object-fit: cover;
            max-width: 189px;
          }
        }
      }

      .news-content {
        width: 50%;
        max-width: 50%;
        box-sizing: border-box;
        padding-left: 6px;
        height: auto;
      }
    }

    .service {
      flex-direction: column;
      .service-left {
        margin-right: 0;
        margin-bottom: 20px;
      }
    }

    .card {
      width: 100%;
      margin: 20px auto 0;
      .card-list {
        flex-wrap: wrap;
        white-space: normal;
      }
      .card-list .card-item {
        width: 48%;
        height: auto;
        min-height: 0;
        margin-right: 0;
        margin-bottom: 12px;
        > .img-box span {
          height: auto;
        }
        > .card-title {
          height: 40px;
          min-height: 40px;
          font-size: 14px;
          line-height: 20px !important;
          max-height: 40px !important;
          padding: 0 10px !important;
          box-sizing: border-box !important;
          white-space: normal !important;
          overflow: hidden !important;
          display: -webkit-box !important;
          -webkit-box-orient: vertical !important;
          -webkit-line-clamp: 2 !important;
          text-overflow: ellipsis !important;
          word-break: break-word !important;
          margin: 8px 0;
        }
        .card-footer {
          display: block !important;
          text-align: left !important;
        }
        .card-footer .custom-name {
          width: 100%;
          height: 32px !important;
          min-height: 32px !important;
          line-height: 16px !important;
          max-height: 32px !important;
          overflow: hidden !important;
          display: -webkit-box !important;
          -webkit-box-orient: vertical !important;
          -webkit-line-clamp: 2 !important;
          text-overflow: ellipsis !important;
          word-break: break-word !important;
          text-align: left !important;
        }
        .card-footer .publish-time {
          width: 100%;
          margin-top: 4px !important;
          text-align: left !important;
          display: block !important;
        }
      }
    }

    .link {
      /* 1. 改变排列方向为垂直堆叠 */
      flex-direction: column;
      align-items: flex-start;
      padding: 10px 5px;

      .link-label {
        width: 100%;        /* 标题占满一行 */
        text-align: left;   /* 手机端建议左对齐，分散对齐在窄屏可能不好看 */
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0; /* 给标题加个下划线更清晰 */
        margin-bottom: 10px;

        /* 如果手机端仍想保持分散对齐，保留下面这行，否则可以重置 */
        text-align-last: left;
      }

      .link-content {
        width: 100%;
        /* 2. 手机端一行展示 2 个或 3 个链接 */
        grid-template-columns: repeat(2, 1fr);
        gap: 10px 8px;

        .link-item {
          padding: 8px 0;

          .link-img {
            max-width: 100%; /* 让图片自适应宽度 */
            height: auto;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .big-box .main {
    .news {
      flex-direction: column;
      .left,
      .news-content {
        width: 100%;
        max-width: 100%;
        padding: 0;
      }
    }
    .card .card-list .card-item {
      width: 48%;
    }
  }
}
</style>

<style>
.swiper-pagination .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  background: #fff;
  opacity: 0.6;
}
.swiper-pagination .swiper-pagination-bullet-active {
  width: 12px;
  height: 12px;
  background: #008bf2 !important;
  opacity: 1;
}
.swiper-prev,
.swiper-next {
  width: 40px;
  height: 80px;
  display: none;
}

.swiper-prev {
  left: 0;
}
.swiper-prev:focus {
  outline: none;
}
.swiper-next:focus {
  outline: none;
}
.swiper-next {
  right: 0;
}
</style>
